import * as React from 'react';
import { SVGProps } from 'react';

const IconAlignJustifySizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1 3h10v1H1V3ZM1 6h10v1H1V6ZM1 9h10v1H1V9Z" />
  </svg>
);
export default IconAlignJustifySizeXs;
